import { handleActions } from 'redux-actions';
import { sum } from 'lodash-es';

import {
  RegistrationValue,
  RegistrationFilterCount,
} from 'ha/types/SearchFilters';

import { RegistrationFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
  isHidden: false,
};

interface Payload {
  filtersCount: {
    registration: RegistrationFilterCount;
  };
  globalFiltersCount: {
    registration: RegistrationFilterCount;
  };
  registration: RegistrationValue;
}

export default handleActions<RegistrationFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.registration,
      isHidden:
        sum(Object.values(payload.globalFiltersCount.registration)) === 0,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { registration = [] } },
    ) => ({
      ...state,
      value: Array.isArray(registration) ? registration : [registration],
    }),
  },
  initialState,
);

export const getRegistrationFilter = (state: RegistrationFilterState) =>
  state.value;
